import React, { Suspense } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faFacebook,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import styles from "./socialIcons.module.css";

const SocialIconsComponent = () => {
  return (
    <div className={styles.homeHeroSocial}>
      <ul className={styles.socialIcons}>
        <Suspense fallback={<div>Loading...</div>}>
          <li>
            <a
              href="https://www.linkedin.com/company/kur-diagnostics-llc/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              {/* <FontAwesomeIcon icon={faLinkedin} /> */}
            </a>
          </li>
          {/* <li>
            <a
              href="https://facebook.com/KURResearch"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>
          </li> */}
          <li>
            {/* <a
              href="https://www.instagram.com/kurresearch/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a> */}
          </li>
        </Suspense>
      </ul>
    </div>
  );
};

export default SocialIconsComponent;
